var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.897 17.1l-.32-4.802q-.09-1.404-.09-2.016a1.827 1.827 0 01.435-1.298 1.499 1.499 0 011.148-.466 1.155 1.155 0 011.153.596 4.036 4.036 0 01.291 1.72 13.139 13.139 0 01-.07 1.344l-.431 4.942a3.873 3.873 0 01-.301 1.353.788.788 0 01-.762.472.758.758 0 01-.752-.456 4.542 4.542 0 01-.3-1.389zm1.113 6.597a1.577 1.577 0 01-1.068-.396 1.389 1.389 0 01-.456-1.108A1.49 1.49 0 0115.99 20.7a1.486 1.486 0 011.078.436 1.424 1.424 0 01.446 1.058 1.4 1.4 0 01-.451 1.103 1.535 1.535 0 01-1.053.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm0 27a13 13 0 1113-13 13 13 0 01-13 13z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--exclamation-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'ExclamationCircleIcon';
export default Icon;